import React from 'react'
import cx from 'classnames'
import style from '../icon.module.scss'
import PropTypes from 'prop-types'
import VegaColors from '../../../../resources/constants/colors.module.scss'
import { VegaIconTypes } from '../IconTypes'
import { VegaIconBreakpoint } from '../IconConstants'
import { VegaIcon } from '../Icon'
import { VegaIconLoading } from '../loading/IconLoading'

const VegaIconBank = ({ className, src = null, size = 16, placeholder = false }) => {
	const isSquared = size >= VegaIconBreakpoint

	if (src !== null && src?.length !== 0) {
		return (
			<img
				className={cx(className, style.iconBank)}
				width={size}
				height={size}
				src={src}
				alt={'Bank'}
			/>
		)
	}

	if (placeholder) {
		return (
			<VegaIcon
				name={'bank'}
				size={size}
				color={VegaColors.SLATE4}
				type={isSquared ? VegaIconTypes.SQUARED : VegaIconTypes.DEFAULT}
				className={cx(className, { [style.bordered]: isSquared })}
			/>
		)
	}

	return <VegaIconLoading size={size} className={cx(className, style.icon)} />
}

VegaIconBank.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** URL of the bank logo */
	src: PropTypes.string,
	/** Width in px of the icon */
	size: PropTypes.number,
	/** Set true if you want placeholder */
	placeholder: PropTypes.bool
}

export { VegaIconBank }
